/**
 * Generated by orval v6.20.0 🍺
 * Do not edit manually.
 * portrich-api
 * OpenAPI spec version: 0.0.0
 */

/**
 * * `COMPREHENSIVE` - 包括保険
* `INDIVIDUAL` - 個別保険
* `TBA` - 後報
 */
export type InsuranceTypeEnum = typeof InsuranceTypeEnum[keyof typeof InsuranceTypeEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InsuranceTypeEnum = {
  COMPREHENSIVE: 'COMPREHENSIVE',
  INDIVIDUAL: 'INDIVIDUAL',
  TBA: 'TBA',
} as const;
